import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { SbHint } from '@kistler/skybase-ui/skybase-components/sb-hint'
import { hintPositions } from '@kistler/skybase-ui/skybase-components/sb-hint/constants'
import { SbLoader } from '@kistler/skybase-ui/skybase-components/sb-loader'
import { openModal } from '@kistler/skybase-ui/skybase-core/base/actions'

import { DOWNLOAD_CALIBRATION_CERTIFICATES_MODAL_ID } from '@/fleet-configuration/components/calibration/download-calibration-certificates-modal/download-calibration-certificates-modal-constants'
import { calibrationShape } from '@/fleet-configuration/equipment/shapes'
import { findComponentByTypeAndSerial } from '@/fleet-configuration/utils/device-utils'
import { messages as t } from './certificate-icon-i18n.js'

export const CertificateIcon = ({ row, calibrations = [] }) => {
  const { formatMessage: _ } = useIntl()
  const dispatch = useDispatch()

  const { modelNumber, serialNumber, typeNumber } = row
  const kistlerTypeNumber = row.getKistlerModelNumber?.() || typeNumber || modelNumber || ''
  const { isLoading, calibrationDocumentsInfo = [] } = findComponentByTypeAndSerial(
    calibrations,
    kistlerTypeNumber,
    serialNumber,
  )

  const [isCalibrationCertificateLoading, setCalibrationsCertificateLoading] = useState(false)

  if (isLoading || isCalibrationCertificateLoading) {
    return (
      <div>
        <SbLoader show />
      </div>
    )
  }

  return (
    <div>
      {calibrationDocumentsInfo.length > 0 ? (
        <SbHint position={hintPositions.topCenter} hintData={_(t.calibrationCertificates)}>
          <span
            className="sbi-file-pdf icon-link show-certificate"
            onClick={() =>
              dispatch(
                openModal(DOWNLOAD_CALIBRATION_CERTIFICATES_MODAL_ID, {
                  calibratedItem: { typeNumber: kistlerTypeNumber, serialNumber },
                  calibrationCertificates: calibrationDocumentsInfo,
                  onUpdateDownloadProgress: isLoading => setCalibrationsCertificateLoading(isLoading),
                }),
              )
            }
          />
        </SbHint>
      ) : (
        <SbHint position={hintPositions.topCenter} hintData={_(t.calibrationCertificatesAreNotAvailable)}>
          <span className="sbi-file-pdf icon-link icon-disabled show-certificate" />
        </SbHint>
      )}
    </div>
  )
}

CertificateIcon.propTypes = {
  calibrations: PropTypes.arrayOf(calibrationShape),
  row: PropTypes.any.isRequired,
}
